import classNames from 'classnames';
import React from 'react';

interface PropTypes {
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function Chip(props: PropTypes) {
  return (
    <small
      className={classNames(
        'badge',
        'rounded-pill',
        'fw-normal',
        props.className,
      )}
      style={props.style}
    >
      {props.children}
    </small>
  );
}
